import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Popup from '../../components/ConformationPopup/Popup';
import { deleteEvaluationData, getEvaluationData, postEvaluationData, updateEvaluationData } from '../../service/adminApi';
import Loader from '../../StaticComponent/Loader';
import { getTimestampToDate } from '../../utils/dateConvetor';

let defaultData = {
    start_date: '',
    end_date: '',
};

let defaultError = {
    yearError: '',
    startDateError: '',
    endDateError: '',
};

let breadCrumbsData = [
    { title: 'Dashboard', isActive: true, path: '/Overview' },
    { title: 'Admin', isActive: true, path: '/admin/accountbranding' },
    { title: 'Perfomance', isActive: true, path: '' },
    { title: 'EvaluationPeriod', isActive: false, path: '' },
];

function EvaluationPeriod() {
    const [evaluationList, setEvaluationList] = React.useState([]);
    const [evaluationData, setEvaluationData] = React.useState(defaultData);
    const [showEvaluationForm, setShowEvaluationForm] = React.useState(false);
    const [nameError, setNameError] = React.useState('');
    const [editId, setEditId] = React.useState('');
    const [flag, setFlag] = React.useState(false);
    const [year, setYear] = React.useState(new Date(new Date().getFullYear(), 0, 1));
    const [evaluationDataError, setEvaluationDataError] = React.useState(defaultError);
    const [deleteIndex, setDeleteIndex] = React.useState();
    const [loading, setLoading] = React.useState(false);

    const handleEvaluationDate = (e) => {
        setEvaluationData((evaluationData) => ({
            ...evaluationData,
            [e.target.name]: e.target.value,
        }));
    };

    React.useEffect(() => {
        let currentYear = new Date(new Date().getFullYear(), 0, 1);
        currentYear = getTimestampToDate(currentYear, 2);
        getEvaluation(currentYear);
    }, []);

    const getEvaluation = async (year) => {
        const response = await getEvaluationData({ year });
        if (response.data.statusCode === 200) {
            setEvaluationList(response.data.data);
        }
        setLoading(true);
    };

    const postEvaluation = async () => {
        try {
            if (validateEvaluationPeriod()) {
                setShowEvaluationForm(false);
                let data = {
                    year: getTimestampToDate(year, 2),
                    start_date: evaluationData.start_date,
                    end_date: evaluationData.end_date,
                };
                if (editId == undefined || editId === '') {
                    const response = await postEvaluationData(data);
                    if (response.data.statusCode === 200) {
                        data['id'] = response.data.data[0].id;
                        setEvaluationList((evaluationList) => [...evaluationList, data]);
                        setEvaluationData(defaultData);
                        setLoading(true);
                    }
                } else {
                    data['id'] = editId;
                    const response = await updateEvaluationData(data);
                    if (response.data.statusCode === 200) {
                        getEvaluation(getTimestampToDate(year, 2));
                        setEvaluationData(defaultData);
                        setLoading(true);
                    }
                }
            }
        } catch (error) {}
    };

    const validateEvaluationPeriod = () => {
        let result = true;
        if (year === undefined || year === '' || year === null) {
            setEvaluationDataError((evaluationDataError) => ({ ...evaluationDataError, yearError: 'Select a valid year' }));
            result = false;
        }
        if (evaluationData.start_date === undefined || evaluationData.start_date === '') {
            result = false;
            setEvaluationDataError((evaluationDataError) => ({ ...evaluationDataError, startDateError: 'Select a valid date' }));
        }
        if (evaluationData.end_date === undefined || evaluationData.end_date === '') {
            result = false;
            setEvaluationDataError((evaluationDataError) => ({ ...evaluationDataError, endDateError: 'Select a valid date' }));
        }
        return result;
    };

    const editEvaluationData = (start_date, end_date) => {
        setShowEvaluationForm(true);
        start_date = getTimestampToDate(start_date, 2);
        end_date = getTimestampToDate(end_date, 2);
        setEvaluationData({ end_date, start_date });
    };

    const removeEvaluationData = async () => {
        try {
            let data = {
                id: evaluationList[deleteIndex].id,
                is_active: false,
            };
            const response = await deleteEvaluationData(data);
            if (response.data.statusCode === 200) {
                let array = evaluationList;
                let arr = array.splice(deleteIndex, 1);
                let updatedData = array;
                setEvaluationList(updatedData);
                setFlag(!flag);
            }
        } catch (e) {
            throw e;
        }
    };

    const renderEvaluationList = () => {
        return evaluationList?.map((list, index) => {
            let start_date = getTimestampToDate(list.start_date, 3);
            let end_date = getTimestampToDate(list.end_date, 3);
            return (
                <div key={index} className="holidaylist-row-table mt-3 custom-input-background holidaylist-bg">
                    <table className="table-style w-100 font-12">
                        <thead>
                            <tr className="th-style">
                                <th className="py-2 holiday-subheader-clr ps-2 font-13 pe-3">Start Date</th>
                                <th></th>
                                <th className="py-2 holiday-subheader-clr ps-2 font-13">End Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="td-style">
                                {/*1st Line*/}
                                <td className="td-style p-2">
                                    <span>
                                        <img src="/Images/calendars.svg" alt="" className="me-2" />
                                        {start_date}
                                    </span>
                                </td>
                                <td>
                                    <div className="mx-3 mb-2">
                                        <img src="/Images/right-arrow-date.svg" />
                                    </div>
                                </td>
                                <td className="td-style p-2">
                                    <span>
                                        <img src="/Images/calendars.svg" alt="" className="me-2" />
                                        {end_date}
                                    </span>
                                </td>

                                <td className="holidaylist-border-left text-center">
                                    <a
                                        onClick={() => {
                                            editEvaluationData(list.start_date, list.end_date);
                                            setEvaluationDataError(defaultError);
                                            setEditId(list.id);
                                        }}
                                        type="button"
                                        className="mx-2"
                                        alt=""
                                    >
                                        <img src="/Images/edit1.svg" className="ms-1" alt="bin" />
                                    </a>
                                    <a
                                        data-bs-toggle="modal"
                                        onClick={() => {
                                            setDeleteIndex(index);
                                        }}
                                        type="button"
                                        data-bs-target="#logout"
                                        className=""
                                        alt=""
                                    >
                                        <img src="/Images/bin.svg" className="ms-3" alt="close" />
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
        });
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbsData} />
            <div className="admin-panel-bg p-3">
                <div className="row">
                    <div className="col-md-11 mb-2">
                        <h5 className="bold-text tt-bold font-18">Evaluation Period</h5>
                        <p className="font-13 regular-text font-grey mb-2">
                            The evaluation period is a three-month period in the organization calendar that is used to evaluate the Team
                            members' performance in that particular evaluation period.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 mb-5">
                        <h1 className="font-14 bold-text tt-bold holiday-btn-spacing mb-3">Select Year</h1>
                        <div className="row justify-content-between mb-4">
                            <div className="col-md-3">
                                <DatePicker
                                    selected={year}
                                    onChange={(date) => {
                                        setYear(date);
                                        getEvaluation(getTimestampToDate(date, 2));
                                    }}
                                    showYearPicker
                                    value={year}
                                    className="form-control custom-input-background custom-textfield font-12"
                                    dateFormat="yyyy"
                                    placeholderText="Year"
                                />
                                <span className="text-danger font-12 medium-text">
                                    {evaluationDataError.yearError.length > 0 ? evaluationDataError.yearError : ''}
                                </span>
                            </div>
                            <div className="col-md-7">
                                <div className='d-flex justify-content-end'>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowEvaluationForm(true);
                                    }}
                                    className="btn hive-btn-primary font-12 bold-text ms-4"
                                >
                                    New Evaluation
                                </button>
                                </div>
                            </div>
                        </div>

                        {showEvaluationForm ? (
                            <div className="holidaylist-row-table ">
                                <table className="table-style w-100 font-12">
                                    <tbody>
                                        <tr className="td-style">
                                            <td className="td-style font-12 medium-text">
                                                <div className="d-flex align-items-end">
                                                    <div className="col-md-4">
                                                        <label
                                                            for="exampleInputEmail1"
                                                            className="form-label py-2 holiday-subheader-clr font-13 pe-3"
                                                        >
                                                            Start Date
                                                            <span className="required">*</span>
                                                        </label>
                                                        <input
                                                            type="date"
                                                            name="start_date"
                                                            value={evaluationData.start_date}
                                                            onChange={(e) => {
                                                                handleEvaluationDate(e);
                                                                setEvaluationDataError((evaluationDataError) => ({
                                                                    ...evaluationDataError,
                                                                    startDateError: '',
                                                                }));
                                                            }}
                                                            className="form-control medium-text custom-input-background font-12 labelcolor custom_textfield"
                                                            id="exampleInputEmail1"
                                                        />
                                                        <span className="text-danger">
                                                            {evaluationDataError.startDateError.length > 0
                                                                ? evaluationDataError.startDateError
                                                                : ''}
                                                        </span>
                                                    </div>
                                                    <div className="mx-3 mb-2">
                                                        <img src="/Images/right-arrow-date.svg" />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label
                                                            for="exampleInputEmail1"
                                                            className="form-label py-2 holiday-subheader-clr font-13 pe-3"
                                                        >
                                                            End Date
                                                            <span className="required">*</span>
                                                        </label>
                                                        <input
                                                            type="date"
                                                            name="end_date"
                                                            min={moment().format(evaluationData.start_date, 'YYYY-MM-DD')}
                                                            value={evaluationData.end_date}
                                                            onChange={(e) => {
                                                                handleEvaluationDate(e);
                                                                setEvaluationDataError((evaluationDataError) => ({
                                                                    ...evaluationDataError,
                                                                    endDateError: '',
                                                                }));
                                                            }}
                                                            className="form-control medium-text custom-input-background font-12 labelcolor custom_textfield"
                                                            id="exampleInputEmail1"
                                                            placeholder="Select Domain"
                                                        />
                                                        <span className="text-danger">
                                                            {evaluationDataError.endDateError.length > 0
                                                                ? evaluationDataError.endDateError
                                                                : ''}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="holidaylist-border-left ps-3">
                                                <a type="button" className="" onClick={() => postEvaluation()} alt="">
                                                    <img src="/Images/tick.svg" className="" alt="tick" />
                                                </a>
                                                <a
                                                    onClick={() => {
                                                        setShowEvaluationForm(false);
                                                        setEditId('');
                                                        setEvaluationData(defaultData);
                                                        setEvaluationDataError(defaultError);
                                                    }}
                                                    type="button"
                                                    className="ps-3"
                                                    alt=""
                                                >
                                                    <img src="/Images/close.svg" className="" alt="close" />
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ) : null}

                        {renderEvaluationList()}
                    </div>
                </div>
            </div>
            <Popup
                deleteData={() => {
                    removeEvaluationData();
                }}
            />
            <Loader isLoading={loading} />
        </div>
    );
}

export default EvaluationPeriod;
